import { render, staticRenderFns } from "./ChatUnreadIndicator.vue?vue&type=template&id=7f545562&scoped=true"
import script from "./ChatUnreadIndicator.vue?vue&type=script&lang=js"
export * from "./ChatUnreadIndicator.vue?vue&type=script&lang=js"
import style0 from "./ChatUnreadIndicator.vue?vue&type=style&index=0&id=7f545562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f545562",
  null
  
)

export default component.exports